<template>
  <section class="privacy-page">
    <div class="container">
      <h1>{{ $t('privacy.title') }}</h1>

      <h2>1. {{ $t('privacy.section1.title') }}</h2>
      <h3>{{ $t('privacy.section1.generalTitle') }}</h3>
      <p>{{ $t('privacy.section1.generalText') }}</p>

      <h3>{{ $t('privacy.section1.dataCollectionTitle') }}</h3>
      <p v-html="$t('privacy.section1.dataCollectionText')"></p>

      <h3>{{ $t('privacy.section1.analyticsTitle') }}</h3>
      <p>{{ $t('privacy.section1.analyticsText') }}</p>

      <h2>2. {{ $t('privacy.section2.title') }}</h2>
      <p v-html="$t('privacy.section2.text')"></p>

      <h2>3. {{ $t('privacy.section3.title') }}</h2>
      <h3>{{ $t('privacy.section3.dataProtectionTitle') }}</h3>
      <p>{{ $t('privacy.section3.dataProtectionText') }}</p>

      <h3>{{ $t('privacy.section3.responsibleTitle') }}</h3>
      <p v-html="$t('privacy.section3.responsibleText')"></p>

      <h3>{{ $t('privacy.section3.storageDurationTitle') }}</h3>
      <p>{{ $t('privacy.section3.storageDurationText') }}</p>

      <h3>{{ $t('privacy.section3.legalBasisTitle') }}</h3>
      <p>{{ $t('privacy.section3.legalBasisText') }}</p>

      <h3>{{ $t('privacy.section3.recipientsTitle') }}</h3>
      <p>{{ $t('privacy.section3.recipientsText') }}</p>

      <h3>{{ $t('privacy.section3.revokeTitle') }}</h3>
      <p>{{ $t('privacy.section3.revokeText') }}</p>

      <h3>{{ $t('privacy.section3.complaintTitle') }}</h3>
      <p>{{ $t('privacy.section3.complaintText') }}</p>

      <h3>{{ $t('privacy.section3.portabilityTitle') }}</h3>
      <p>{{ $t('privacy.section3.portabilityText') }}</p>

      <h3>{{ $t('privacy.section3.infoDeleteTitle') }}</h3>
      <p>{{ $t('privacy.section3.infoDeleteText') }}</p>

      <h3>{{ $t('privacy.section3.restrictionTitle') }}</h3>
      <p>{{ $t('privacy.section3.restrictionText') }}</p>

      <h3>{{ $t('privacy.section3.sslTitle') }}</h3>
      <p>{{ $t('privacy.section3.sslText') }}</p>

      <h2>4. {{ $t('privacy.section4.title') }}</h2>
      <h3>{{ $t('privacy.section4.serverLogsTitle') }}</h3>
      <p v-html="$t('privacy.section4.serverLogsText')"></p>

      <h3>{{ $t('privacy.section4.contactTitle') }}</h3>
      <p>{{ $t('privacy.section4.contactText') }}</p>

      <h2>5. {{ $t('privacy.section5.title') }}</h2>
      <h3>{{ $t('privacy.section5.googleFontsTitle') }}</h3>
      <p v-html="$t('privacy.section5.googleFontsText')"></p>

      <p class="source">{{ $t('privacy.source') }}</p>
      <p class="last-updated">{{ $t('privacy.lastUpdated') }}</p>
    </div>
  </section>
</template>

<style scoped>
.privacy-page {
  padding: 100px 20px 60px;
  background-color: var(--bg-color);
}

.container {
  max-width: 800px;
  margin: 0 auto;
}

h1 {
  margin-bottom: 40px;
  font-size: 2rem;
}

h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 1.4rem;
  color: var(--primary-color);
}

h3 {
  margin-top: 24px;
  margin-bottom: 8px;
  font-size: 1.1rem;
}

p {
  line-height: 1.8;
  margin-bottom: 12px;
  opacity: 0.9;
}

.source {
  margin-top: 40px;
  font-size: 0.85rem;
  opacity: 0.6;
}

.last-updated {
  font-size: 0.85rem;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .privacy-page {
    padding: 80px 15px 40px;
  }
}
</style>
